import { createContext } from 'react';

export const PopupFormParentContext = createContext<string>('');
